import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery'
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import StudentPage from '../../views/StudentPage';
import Sanitize from '../../Sanitize';
const GLOBAL = require('../../Globals');

class AttendanceView extends Component {

	constructor(props) {
		super(props);
		this.state = {
			id: '',
			acyear: '',
			cls: '',
			section: '',
			year: '',
			month: '',
			attdate: moment(),
			_message: '',
			alertClass: '',
			posts: [],
			stud: [],
			data: [],
			accyear: [],
			_redirect: false,
			isview: false,
			chk: '',
			att: [],
			remark: [],
			events: [],
			postFilter: [],
			adata: [],
			sections: [],
			allocateClass : [],
		}

		this.onChange = this.onChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onClassChange = this.onClassChange.bind(this);
		this.onSecChange = this.onSecChange.bind(this);
		this.onYearChange = this.onYearChange.bind(this);
		this.onMonChange = this.onMonChange.bind(this);
	}

	onView(e){
		this.setState({isview : true});
		this.getdata();
	}

	/** set value to Attendance datepicker **/
	handleChange(date) {
		this.setState({
			attdate: date
		});
	}

	onSecChange(e) {

		this.state.section = e.target.value;
		this.filterdata();
	}

	onClassChange(e) {

		this.state.cls = e.target.value;
		this.setState({ cls: e.target.value });
		this.getsection();
		this.filterdata();
	}

	getsection() {
		var ar = $("#year").val();
		$("#showLoader").show();
		GetData('section/getsecbyclass/' + ar + '/' + this.state.cls).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					sections: responseJson
				});
			}
		});
	}

	onYearChange(e) {

		this.state.year = e.target.value;
		this.filterdata();
	}

	onMonChange(e) {

		this.state.month = e.target.value;
		this.filterdata();
	}

	onChange(e) {

		this.setState({ [e.target.name]: e.target.value });
		var today = new Date();
		/* console.log('date '+today);
		console.log(this.state); */
		this.getstudent();
		this.daysInMonth();
		this.getleave();
	}

	/** this function will be call when page loading **/
	componentWillMount() {

		this.getclass();
		this.getacyear();
		this.getleave();
	}

	/** get Leave Days **/
	getleave() {
		$("#showLoader").show();
		GetData('student/getleave').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					events: responseJson
				});
			}
		});
	}

	/** get Class **/
	getclass() {
		$("#showLoader").show();
		GetData('classs/getclass').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}

	/** Get Academic Year **/
	getacyear() {
		$("#showLoader").show();
		GetData('academic/getacyear').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				
				let userData = JSON.parse(sessionStorage.getItem('userData'));
				this.state.userId = userData['userid'];
				this.state.userRole = userData['userrole'];
				this.state.staffid = userData['staffid'];
				this.setState({
					staffid: userData['staffid']
				});
				if(userData['userrole'] == 'classteacher'){
					this.checkclassteacher();
				}
				this.getstudent();
				this.filterdata();
			}
		});
	}
	
	checkclassteacher(){
		$("#showLoader").show();
		GetData('employee/checkclassteacher/'+this.state.acyear+'/'+this.state.staffid).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					allocateClass : responseJson
				});
			}
			$("#showLoader").hide();
		});
	}

	/** get Student **/
	getstudent() {
		this.setState({ stud: [] });
		var ac = $("#year").val();
		$("#showLoader").show();
		GetData('student/getstdbyac/' + ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					stud: responseJson,
					postFilter: responseJson
				});
			}
		});
	}

	getdata() {

		this.setState({ data: [] });
		var ac = $("#year").val();
		$("#showLoader").show();
		GetData('student/getattendance/' + ac+'/'+this.state.cls+'/'+this.state.section+'/'+this.state.year+'/'+this.state.month).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					//data: responseJson,
					adata: responseJson
				});
			}
		});
	}

	getabsent(stdid) {

		var ab = [];

		var month = $("#month").val();
		var year = $("#syear").val();

		for (var i = 1; i < this.daysInMonth(); i++) {

			if (this.checksunday(i)) {

				ab.push(<td id="sunback"><span id="attsun"><b style={{ color: '#f86c6b' }}>S</b></span></td>);
			}
			else if (this.checksaturday(i) && this.state.cls < 4) {

				ab.push(<td><span id="attpre"><b style={{ color: '#ffc107' }}>H</b></span></td>);
			}
			else {

				if (this.chkevents(i, month, year)) {

					ab.push(<td><span id="attpre"><b style={{ color: '#ffc107' }}>H</b></span></td>);

				}
				else {

					if (this.getcurdate(i)) {

						if (this.checkabsent(stdid, i, 'morning') && this.checkabsent(stdid, i, 'evening')) {

							ab.push(<td><span id="abs"><b style={{ color: 'red' }}>AA</b></span></td>);
						}
						else if (this.checkabsent(stdid, i, 'morning')) {

							ab.push(<td><span id="abs"><b style={{ color: 'red' }}>A </b><b style={{ color: 'green' }}>/</b></span></td>);
						}
						else if (this.checkabsent(stdid, i, 'evening')) {

							ab.push(<td><span id="abs"><b style={{ color: 'green' }}>/</b><b style={{ color: 'red' }}> A</b></span></td>);
						}
						else {

							ab.push(<td><span id="attpre"><b style={{ color: '#4dbd74' }}>X</b></span></td>);
						}
					}
					else {
						ab.push(<td></td>);
					}
				}

			}
		}

		return ab;
	}

	getcurdate(date) {
		var bstate = false;
		var month = $("#month").val();
		var year = $("#syear").val();
		var newDate = new Date('' + year + '-' + month + '-' + this.addzero(date)).getTime();
		var today = new Date().getTime();

		if (newDate <= today) {

			bstate = true;
		}
		else {

			bstate = false;
		}
		return bstate;
	}

	//Check Leave
	chkevents(date, month, year) {

		var newDate = year + '-' + month + '-' + this.addzero(date);
		var dfsadg = new Date(newDate).getTime();
		var classs = this.state.cls;
		var bstate = false;
		for (var j = 0; j < this.state.events.length; j++) {

			var s1 = new Date(this.state.events[j].start).getTime();
			var e1 = new Date(this.state.events[j].end).getTime();

			if (dfsadg >= s1 && dfsadg < e1) {

				var cls = this.state.events[j].sclass;
				var str = cls.split(',');
				for (var i = 0; i < str.length; i++) {
					if (str[i] == classs) {
						bstate = true;
					}
				}
				break;
			}
			else {

				bstate = false;
			}
		}
		return bstate;

	}

	countdays() {

		var days = [];

		for (var k = 0; k < this.state.events.length; k++) {

			for (var j = 0; j < this.state.events[k].countdays; j++) {
				var tem = new Date(this.state.events[k].start);
				var dfgdf = tem.setDate(tem.getDate() + j);
				days.push(dfgdf);
			}
		}
	}

	addzero(day) {
		var temp = '' + day;
		if (temp.length == 1) {

			temp = "0" + temp;
			return temp;
		}
		else {

			return temp;
		}

	}

	checksclday(dd) {

		var boolstate = false;
		for (var ii = 0; ii < this.state.adata.length; ii++) {

			if (this.state.adata[ii].day == dd) {

				boolstate = true;
				break;
			}
			else {
				boolstate = false;
			}

		}
		return boolstate;

	}

	checkabsent(stdid, day, type) {

		var boolstate = false;
		for (var ii = 0; ii < this.state.adata.length; ii++) {

			if (this.state.adata[ii].student == stdid && this.state.adata[ii].day == day && this.state.adata[ii].type == type) {

				boolstate = true;
				break;
			}
			else {
				boolstate = false;
			}

		}
		return boolstate;
	}

	getdays() {
		var days = [];

		for (var i = 1; i < this.daysInMonth(); i++) {

			days.push(<td>{i}</td>);
		}

		return days;
	}

	checksunday(dat) {
		var bstate = false;
		var month = $("#month").val();
		var year = $("#syear").val();

		var newDate = new Date('' + year + '-' + month + '-' + dat);
		// console.log('date '+newDate);
		if (newDate.getDay() == 0) {   //if Sunday
			bstate = true;
		}
		return bstate;
	}

	checksaturday(dat) {
		var bstate = false;
		var month = $("#month").val();
		var year = $("#syear").val();

		var newDate = new Date('' + year + '-' + month + '-' + dat);
		if (newDate.getDay() == 6) {   //if Saturday
			bstate = true;
		}
		return bstate;
	}

	daysInMonth() {

		var month = $("#month").val();
		var year = $("#syear").val();
		var ndays = new Date(year, month, 0).getDate();
		return ndays + 1;
	}

	filterdata() {

		this.state.postFilter = [];
		var dat = [];
		for (var i = 0; i < this.state.stud.length; i++) {

			if (this.state.cls != '' && this.state.section != '' && this.state.year != '' && this.state.month != '') {

				if (this.state.stud[i].class == this.state.cls && this.state.stud[i].section == this.state.section) {

					dat.push(this.state.stud[i]);
				}
			}

		}
		this.setState({ postFilter: dat });
	}

	filterabdata() {

		this.state.adata = [];
		var dat = [];
		for (var i = 0; i < this.state.data.length; i++) {

			if (this.state.cls != '' && this.state.section != '' && this.state.year != '' && this.state.month != '') {

				if (this.state.data[i].class == this.state.cls && this.state.data[i].section == this.state.section && this.state.data[i].year == this.state.year && this.state.data[i].month == this.state.month) {

					dat.push(this.state.data[i]);
				}
			}

		}
		this.setState({ adata: dat });
	}
	
	checkClass(cls){
		var bstate = false;
		var d = this.state.allocateClass;
		var index = d.findIndex(function(obj){
			return(obj.class == cls);
		});
		if(index > -1){
			bstate = true;
		}
		return bstate;
	}
	
	checkSection(sec){
		var bstate = false;
		var d = this.state.allocateClass;
		var index = d.findIndex(function(obj){
			return(obj.section == sec);
		});
		if(index > -1){
			bstate = true;
		}
		return bstate;
	}

	render() {

		/** get year only select box **/
		const currentYear = new Date().getFullYear();
		const fromMonth = new Date(currentYear - 1, 0);
		const toMonth = new Date(currentYear + 10, 11);

		const years = [];
		for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
			years.push(i);
		}

		var items = this.state.posts;
		var sub = this.state.subj;
		var tea = this.state.teach;
		var acyear = this.state.accyear;

		if (this.state.isview) {

			$("#attab").show();
		}
		else {

			$("#attab").hide();
		}

		$('.selectall').click(function () {
			if ($(this).is(':checked')) {
				$('table input').attr('checked', true);
			} else {
				$('table input').attr('checked', false);
			}
		});

		/** set month in select box **/
		this.month = [
			{ value: '', name: 'Select Month' },
			{ value: '01', name: 'January' },
			{ value: '02', name: 'February' },
			{ value: '03', name: 'March' },
			{ value: '04', name: 'April' },
			{ value: '05', name: 'May' },
			{ value: '06', name: 'June' },
			{ value: '07', name: 'July' },
			{ value: '08', name: 'August' },
			{ value: '09', name: 'September' },
			{ value: '10', name: 'October' },
			{ value: '11', name: 'November' },
			{ value: '12', name: 'December' }
		];

		return (
			<div>
				<StudentPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						<Col md="12">
							<Card>
								<CardHeader>
									<strong>View Attendance</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
									Academic Year : &nbsp;&nbsp;
									<select name="acyear" onChange={this.onChange} required id="year">
										<option value="">Select</option>
										{
											acyear.map(function (item) {
												return <option value={item.id}>{item.value}</option>;
											})
										}
									</select>
								</CardHeader>
								<CardBody>
									<Row>
										<Col md="2" sm={12} xs={12}>
											<FormGroup>
												<Label htmlFor="name">Class <span className="text-danger">*</span></Label>
												<select name="cls" onChange={this.onClassChange} className="form-control" id="clas" required>
													<option value="">Select Class</option>
													{(this.state.userRole == 'classteacher') ?
														items.map((item)=>{
															if(this.checkClass(item.id)){
																return <option value={item.id}>{item.class}</option>;
															}
														})
														:
														items.map(function (item) {
															return <option value={item.id}>{item.class}</option>;
														})
													}
												</select>
											</FormGroup>
										</Col>
										<Col md="2" sm={12} xs={12}>
											<FormGroup>
												<Label htmlFor="name">Section <span className="text-danger">*</span></Label>
												<select name="section" onChange={this.onSecChange} className="form-control" id="secs" required>
													<option value="">Select Section</option>
													{(this.state.userRole == 'classteacher') ?
														this.state.sections.map((item)=>{
															if(this.checkSection(item.id)){
																return <option value={item.id}>{item.secs}</option>;
															}
														})
														:
														this.state.sections.map(function (item) {
															return <option value={item.id}>{item.secs}</option>;
														})
													}
												</select>
											</FormGroup>
										</Col>
										<Col md="2" sm={12} xs={12}>
											<FormGroup>
												<Label htmlFor="name">Year</Label>
												<select name="year" className="form-control" onChange={this.onYearChange} required id="syear">
													<option value="">Select Year</option>
													{years.map(year => (
														<option key={year} value={year}>
															{year}
														</option>
													))}
												</select>
											</FormGroup>
										</Col>
										<Col md="2" sm={12} xs={12}>
											<FormGroup>
												<Label htmlFor="name">Month <span className="text-danger">*</span></Label>
												<select name="month" className="form-control" onChange={this.onMonChange} required id="month">
													{this.month.map((e, key) => {
														return <option key={key} value={e.value}>{e.name}</option>;
													})}
												</select>
											</FormGroup>
										</Col>
										<Col md="1" sm={6} xs={6}>
											<FormGroup>
												<Button color="primary" size="md"  style={{marginTop : '27px'}} onClick={this.onView.bind(this)}>View</Button>
											</FormGroup>
										</Col>
										<Col md="2" sm={6} xs={6} style={{marginTop : '30px'}}>
											<FormGroup>
												<ReactHTMLTableToExcel
												id="test-table-xls-button"
												className="download-table-xls-button btn-success"
												table="atttable"
												filename={Sanitize.getClass(this.state.cls) + ' ' + Sanitize.getSection(this.state.section)+ ' - ' +Sanitize.getMonthName(this.state.month)+' '+this.state.year}
												sheet="Attendance Report"
												buttonText="Excel Export" />
											</FormGroup>
										</Col>
									</Row>
									<Row id="attab">
										<Col md="12">
											<Table responsive bordered id="atttable">
												<thead>
													<tr>
														<td>Regno</td>
														<td>Name</td>
														{this.getdays()}
													</tr>
												</thead>
												<tbody>
													{this.state.postFilter.map((item, index) =>

														<tr key={index}>
															<td>{item.regno}</td>
															<td>{item.stdname}</td>
															{this.getabsent(item.regno)}
														</tr>
													)}
												</tbody>
											</Table>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		)
	}
}

export default AttendanceView;


// WEBPACK FOOTER //
// ./src/student/Attendance/AttendanceView.js